import classNames from "classnames"
import PropTypes from "prop-types"
import infoIcon from "../SmsScreen/assets/info-icon.svg"
import styles from "./InfoCard.module.scss"

const InfoCard = ({ header, secondaryHeader, text, className }) => {
  if (!text && !header) {
    return null
  }

  return (
    <div className={classNames(styles.infoCard, "mb-4", className)}>
      <div className="d-flex align-items-center mb-3">
        <img src={infoIcon} className="me-1" alt="info" />
        {header && <h3 className="fw-bold">{header}</h3>}
      </div>
      {header && (
        <div className={styles.infoText}>
          {secondaryHeader && (
            <div className="fw-bold d-block mb-1">{secondaryHeader}</div>
          )}
          {text && (
            <div
              className={styles.infoAnswer}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
      )}
      {!header && text && (
        <div
          className={styles.infoAnswer}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  )
}

InfoCard.propTypes = {
  header: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  secondaryHeader: PropTypes.string
}

export default InfoCard
